"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateResourceSchema = exports.createResourceSchema = exports.resourceSchema = exports.resourceAvailabilitySchema = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
const localDate_js_1 = require("../localDate.js");
exports.resourceAvailabilitySchema = zod_1.z
    .object({
    day: zod_1.z.enum(enums_js_1.DayOfWeeks),
    startMin: localDate_js_1.timeMinSchema,
    endMin: localDate_js_1.timeMinSchema,
})
    .refine((v) => v.startMin < v.endMin, { message: 'startMin must be less than endMin' });
exports.resourceSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: zod_1.z.enum(enums_js_1.ResourceTypes),
    displayName: zod_1.z.string().min(1),
    capacity: zod_1.z.number().int().positive(),
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService),
    active: zod_1.z.boolean(),
    externalRef: zod_1.z.string().nullable().optional(),
    firstName: zod_1.z.string().nullable().optional(),
    lastName: zod_1.z.string().nullable().optional(),
    email: zod_1.z.string().email().nullable().optional(),
    cellPhone: zod_1.z.string().nullable().optional(),
    providerRole: zod_1.z.enum(enums_js_1.ProviderRoles).nullable().optional(),
    serviceTypes: zod_1.z.array(zod_1.z.enum(enums_js_1.ServiceTypes)),
    maxDirectHoursPerWeek: zod_1.z.number().int().nullable().optional(),
    travelBufferMin: zod_1.z.number().int().nullable().optional(),
    telehealthCapable: zod_1.z.boolean().optional(),
    groupServiceType: zod_1.z.enum(enums_js_1.GroupServiceTypes).nullable().optional(),
    defaultDays: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)),
    defaultStartMin: localDate_js_1.timeMinSchema.nullable().optional(),
    defaultEndMin: localDate_js_1.timeMinSchema.nullable().optional(),
    staffResourceIds: zod_1.z.array(zod_1.z.string().uuid()),
    roomResourceId: zod_1.z.string().uuid().nullable().optional(),
    roomName: zod_1.z.string().nullable().optional(),
    notes: zod_1.z.string().nullable().optional(),
    availability: zod_1.z.array(exports.resourceAvailabilitySchema),
    enrollmentCount: zod_1.z.number().int().min(0).optional(),
});
exports.createResourceSchema = zod_1.z
    .object({
    type: zod_1.z.enum(enums_js_1.ResourceTypes),
    displayName: zod_1.z.string().min(1).optional(),
    capacity: zod_1.z.number().int().positive().optional(),
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService).default('OFFICE'),
    externalRef: zod_1.z.string().optional(),
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    email: zod_1.z.string().email().optional(),
    cellPhone: zod_1.z.string().optional(),
    providerRole: zod_1.z.enum(enums_js_1.ProviderRoles).optional(),
    serviceTypes: zod_1.z.array(zod_1.z.enum(enums_js_1.ServiceTypes)).default([]),
    maxDirectHoursPerWeek: zod_1.z.number().int().min(0).max(80).optional(),
    travelBufferMin: zod_1.z.number().int().min(0).max(120).optional(),
    telehealthCapable: zod_1.z.boolean().optional(),
    groupServiceType: zod_1.z.enum(enums_js_1.GroupServiceTypes).optional(),
    defaultDays: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)).default([]),
    defaultStartMin: localDate_js_1.timeMinSchema.optional(),
    defaultEndMin: localDate_js_1.timeMinSchema.optional(),
    staffResourceIds: zod_1.z.array(zod_1.z.string().uuid()).default([]),
    roomResourceId: zod_1.z.string().uuid().optional(),
    availability: zod_1.z.array(exports.resourceAvailabilitySchema).default([]),
    notes: zod_1.z.string().optional(),
})
    .refine((v) => {
    if (v.type === 'PROVIDER' || v.type === 'COMMUNITY_PROVIDER') {
        return !!v.providerRole && !!v.firstName && !!v.lastName;
    }
    if (v.type === 'GROUP') {
        return !!v.groupServiceType;
    }
    return true;
}, { message: 'Resource fields incomplete for the selected type' });
exports.updateResourceSchema = zod_1.z
    .object({
    displayName: zod_1.z.string().min(1).optional(),
    capacity: zod_1.z.number().int().positive().optional(),
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService).optional(),
    active: zod_1.z.boolean().optional(),
    externalRef: zod_1.z.string().nullable().optional(),
    firstName: zod_1.z.string().nullable().optional(),
    lastName: zod_1.z.string().nullable().optional(),
    email: zod_1.z.string().email().nullable().optional(),
    cellPhone: zod_1.z.string().nullable().optional(),
    providerRole: zod_1.z.enum(enums_js_1.ProviderRoles).nullable().optional(),
    serviceTypes: zod_1.z.array(zod_1.z.enum(enums_js_1.ServiceTypes)).optional(),
    maxDirectHoursPerWeek: zod_1.z.number().int().min(0).max(80).nullable().optional(),
    travelBufferMin: zod_1.z.number().int().min(0).max(120).nullable().optional(),
    telehealthCapable: zod_1.z.boolean().optional(),
    groupServiceType: zod_1.z.enum(enums_js_1.GroupServiceTypes).nullable().optional(),
    defaultDays: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)).optional(),
    defaultStartMin: localDate_js_1.timeMinSchema.nullable().optional(),
    defaultEndMin: localDate_js_1.timeMinSchema.nullable().optional(),
    staffResourceIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
    roomResourceId: zod_1.z.string().uuid().nullable().optional(),
    locationId: zod_1.z.string().uuid().nullable().optional(),
    availability: zod_1.z.array(exports.resourceAvailabilitySchema).optional(),
    notes: zod_1.z.string().nullable().optional(),
});
//# sourceMappingURL=resource.js.map